import { getCookie } from '../helpers/cookies';
const setFieldValue = (fieldName, value) => {
    const field = document.querySelector(`input[name="${fieldName}"]`);
    if (field && value !== null && value.trim() !== '') {
        try {
            field.value = decodeURIComponent(value.replace(/\+/g, ' '));
        }
        catch (error) {
            console.error(`Error decoding URI component: ${error}`);
        }
    }
};
const prefillFormFields = () => {
    const urlParams = new URLSearchParams(window.location.search);
    setFieldValue('username', getCookie('username'));
    setFieldValue('first_name', urlParams.get('firstname'));
    setFieldValue('last_name', urlParams.get('lastname'));
    setFieldValue('username', urlParams.get('username'));
    setFieldValue('email1', urlParams.get('email'));
    setFieldValue('phone_number_c', urlParams.get('phone'));
    const usernameParam = urlParams.get('username');
    if (usernameParam) {
        submitForm();
    }
};
const submitForm = () => {
    const form = document.querySelector('.customer-referral-form form');
    if (form) {
        const event = new Event('submit', {
            bubbles: true,
            cancelable: true,
        });
        form.dispatchEvent(event);
    }
};
export const initPrefill = () => {
    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', prefillFormFields)
        : prefillFormFields();
};
